import { useRouter } from 'next/router'
import { useState } from 'react'

import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { DEFAULT_RUB_ADVANCE, DEFAULT_USD_ADVANCE } from '@/lib/constants'
import { DeviceOrderData } from '@/lib/schemes'
import { Device } from '@/lib/types'
import { formatCurrency } from '@/lib/utils'

import useRenderSide from '@/hooks/auth/useRenderSide'
import { useSignInStore } from '@/hooks/stores/useSignInStore'

export const useShopCardPaymentBlock = ({
  device,
  openOrderingModal,
  openInstallmentModal
}: {
  device: Device
  openOrderingModal: () => void
  openInstallmentModal: () => void
}) => {
  const { locale } = useRouter()
  const [deviceOrderSchema, setDeviceOrderSchema] = useState(z.object({}))
  const { isSignedIn } = useRenderSide()
  const { openSignInModal } = useSignInStore()

  const isUSD = device.currency === 'USD'

  const form = useForm<DeviceOrderData>({
    defaultValues: {
      advance: isUSD ? DEFAULT_USD_ADVANCE : DEFAULT_RUB_ADVANCE,
      paymentMethod: null,
      useBonusBalance: false
    },
    resolver: zodResolver(deviceOrderSchema)
  })

  const { annualForecast, currency } = device

  const profit = formatCurrency(
    annualForecast?.['100k'].total,
    currency,
    locale
  )

  const onDeviceOrder = async (installment?: boolean) => {
    if (isSignedIn) {
      installment ? openInstallmentModal() : openOrderingModal()
    } else {
      openSignInModal()
    }
  }

  return { setDeviceOrderSchema, profit, onDeviceOrder, form }
}
